<template>
  <p class="ren-decoration-cp ren-decoration-cp-rich-text" :style="textStyle">{{ plainText }}</p>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { numberValue, stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const plainText = computed(() =>
  stringValue(props.component.props?.html ?? props.component.props?.text, '请输入内容')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
)

const textStyle = computed(() => {
  const style = props.component.style ?? {}
  const fontSize = Number(style.fontSize)
  const lineHeight = numberValue(style.lineHeight, 0)
  const color = stringValue(style.textColor)
  return {
    color: color || undefined,
    fontSize: Number.isFinite(fontSize) && fontSize > 0 ? `${fontSize}px` : undefined,
    lineHeight: lineHeight > 0 ? String(lineHeight) : undefined
  }
})
</script>

<style scoped>
.ren-decoration-cp-rich-text {
  margin: 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  line-height: 1.65;
}
</style>
